import { Link } from 'react-router-dom';
import { SecondaryButton } from '../../../components/SecondaryButton';
import { Dispatch, RefObject, SetStateAction } from 'react';

interface CsvSubmitInterface {
  downloadExampleFileRef: RefObject<HTMLAnchorElement>;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
}

export default function CsvSubmit({
  downloadExampleFileRef,
  setIsModalVisible,
}: CsvSubmitInterface) {
  return (
    <>
      <Link
        to="/files/Modelo importar arquivo de triangulacao.csv"
        target="_blank"
        download
        style={{ display: 'none' }}
        ref={downloadExampleFileRef}
      />
      <SecondaryButton onClick={() => { downloadExampleFileRef.current!.click();}}>
        Exemplo CSV
      </SecondaryButton>
      <SecondaryButton onClick={() => {setIsModalVisible(true);}} >
        Importar CSV
      </SecondaryButton>
    </>
  );
}
